import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import DescriptionIcon from '@mui/icons-material/Description';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
			},
		],
	},
	{
		title: 'Pages',
		pages: [
			{
				title: 'Builder',
				href: '/builder',
				icon: DescriptionIcon,
				roles: ['Administrator']
			},
			{
				title: 'Kpis',
				href: '/kpis',
				icon: ShowChartIcon,
				// roles: ['Administrator', ...]
				children: [
					{
						title: 'Uploads',
						href: '/kpis/uploads',
					},
					{
						title: 'Reports',
						href: '/kpis/reports',
					}
				],
			},
			{
				title: 'Scripting',
				href: '/scripting',
				icon: ReceiptIcon,
				// roles: ['Administrator', ...]
				children: [
					{
						title: 'Retune Scripting',
						href: '/scripting/retuneScripting',
					},
					{
						title: 'DSS 2100',
						href: '/scripting/dss2100Scripting',
					}
				],
			},
			{
				title: 'Tracker',
				href: '/tracker',
				icon: CalendarTodayIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				children: [
					{
						title: 'Activity Status',
						href: '/tracker/activity',
					},
					{
						title: 'Element Status',
						href: '/tracker/element',
					}
				],
			},
			{
				title: 'Dashboards',
				href: '/dashboards',
				icon: DashboardIcon,
				// roles: ['Administrator', ...]
				children: [
					{
						title: 'Global Validation',
						href: '/dashboards/inspect/1',
					},
					{
						title: 'Data Integrity',
						href: '/dashboards/inspect/2',
					},
				],
			},
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	},
	/* {
		title: 'Demo',
		pages: [
			{
				title: 'Overview',
				href: '/overview',
				icon: HomeIcon,
			},
			{
				title: 'Dashboards',
				href: '/dashboards',
				icon: DashboardIcon,
				children: [
					{
						title: 'Default',
						href: '/dashboards/default',
					},
					{
						title: 'Analytics',
						href: '/dashboards/analytics',
					},
				],
			},
			{
				title: 'Management',
				href: '/management',
				icon: BarChartIcon,
				children: [
					{
						title: 'Customers',
						href: '/management/customers',
					},
					{
						title: 'Customer Details',
						href: '/management/customers/1/summary',
					},
					{
						title: 'Projects',
						href: '/management/projects',
					},
					{
						title: 'Orders',
						href: '/management/orders',
					},
					{
						title: 'Order Details',
						href: '/management/orders/1',
					},
				],
			},
			{
				title: 'Social Feed',
				href: '/social-feed',
				icon: PeopleIcon,
			},
			{
				title: 'Profile',
				href: '/profile',
				icon: PersonIcon,
				children: [
					{
						title: 'Timeline',
						href: '/profile/1/timeline',
					},
					{
						title: 'Connections',
						href: '/profile/1/connections',
					},
					{
						title: 'Projects',
						href: '/profile/1/projects',
					},
					{
						title: 'Reviews',
						href: '/profile/1/reviews',
					},
				],
			},
			{
				title: 'Project',
				href: '/projects',
				icon: FolderIcon,
				children: [
					{
						title: 'Browse',
						href: '/projects',
					},
					{
						title: 'Create',
						href: '/projects/create',
					},
					{
						title: 'Overview',
						href: '/projects/1/overview',
					},
					{
						title: 'Files',
						href: '/projects/1/files',
					},
					{
						title: 'Activity',
						href: '/projects/1/activity',
					},
					{
						title: 'Subscribers',
						href: '/projects/1/subscribers',
					},
				],
			},
			{
				title: 'Invoice',
				href: '/invoices/1',
				icon: ReceiptIcon,
			},
			{
				title: 'Kanban Board',
				href: '/kanban-board',
				icon: ListAltIcon,
			},
			{
				title: 'Mail',
				href: '/mail',
				icon: MailIcon,
				label: () => (
					<Label color={colors.red[500]} shape="rounded">
						2
					</Label>
				),
			},
			{
				title: 'Chat',
				href: '/chat',
				icon: ChatIcon,
				label: () => (
					<Label color={colors.red[500]} shape="rounded">
						4
					</Label>
				),
			},
			{
				title: 'Calendar',
				href: '/calendar',
				icon: CalendarTodayIcon,
				label: () => <Label color={colors.green[500]}>New</Label>,
			},
			{
				title: 'Settings',
				href: '/settings',
				icon: SettingsIcon,
				children: [
					{
						title: 'General',
						href: '/settings/general',
					},
					{
						title: 'Subscription',
						href: '/settings/subscription',
					},
					{
						title: 'Notifications',
						href: '/settings/notifications',
					},
					{
						title: 'Security',
						href: '/settings/security',
					},
				],
			},
			{
				title: 'Authentication',
				href: '/auth',
				icon: LockOpenIcon,
				children: [
					{
						title: 'Login',
						href: '/auth/login',
					},
					{
						title: 'Register',
						href: '/auth/register',
					},
				],
			},
			{
				title: 'Errors',
				href: '/errors',
				icon: ErrorIcon,
				children: [
					{
						title: 'Error 401',
						href: '/errors/error-401',
					},
					{
						title: 'Error 404',
						href: '/errors/error-404',
					},
					{
						title: 'Error 500',
						href: '/errors/error-500',
					},
				],
			},
		],
	},

	{
		title: 'Support',
		pages: [
			{
				title: 'Presentation',
				href: '/presentation',
				icon: PresentToAllIcon,
			},
			{
				title: 'Getting started',
				href: '/getting-started',
				icon: CodeIcon,
			},
			{
				title: 'Changelog',
				href: '/changelog',
				icon: ViewModuleIcon,
				label: () => <Label color={colors.blue['500']}>v1.2.0</Label>,
			},
		],
	}, */
];
